import { useState } from "react";

const WHATSAPP_NUMBER = "8618688888888";
const WECHAT_ID = "CrownGlobal_Trade";
const PHONE_NUMBER = "+86 186 8888 8888";
const EMAIL = "trade@crownglobal.com";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [wechatCopied, setWechatCopied] = useState(false);

  const copyWechat = (e: React.MouseEvent) => {
    e.preventDefault();
    navigator.clipboard.writeText(WECHAT_ID).then(() => {
      setWechatCopied(true);
      setTimeout(() => setWechatCopied(false), 2000);
    });
  };

  return (
    <div className="fixed right-4 bottom-20 md:bottom-8 z-50 flex flex-col items-end gap-2">
      {/* Expanded options */}
      {open && (
        <div className="flex flex-col gap-2 mb-1 items-end">

          {/* WhatsApp with real number */}
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hello%20Crown%20Global%2C%20I%20am%20interested%20in%20factory%20sourcing.`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white text-xs font-bold px-4 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.15)" }}
          >
            <i className="ri-whatsapp-line text-base"></i>
            <div className="flex flex-col leading-none">
              <span>WhatsApp</span>
              <span className="text-green-100 font-normal text-[10px] mt-0.5">+86 186 8888 8888</span>
            </div>
          </a>

          {/* WeChat — copy ID */}
          <button
            onClick={copyWechat}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white text-xs font-bold px-4 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.15)" }}
          >
            <i className="ri-wechat-line text-base"></i>
            <div className="flex flex-col leading-none text-left">
              <span>{wechatCopied ? "Copied!" : "WeChat"}</span>
              <span className="text-green-100 font-normal text-[10px] mt-0.5">
                {wechatCopied ? "ID copied to clipboard" : WECHAT_ID}
              </span>
            </div>
          </button>

          {/* Email */}
          <a
            href={`mailto:${EMAIL}?subject=Factory%20Sourcing%20Inquiry`}
            className="flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white text-xs font-bold px-4 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.15)" }}
          >
            <i className="ri-mail-line text-base"></i>
            <div className="flex flex-col leading-none">
              <span>Email Us</span>
              <span className="text-amber-100 font-normal text-[10px] mt-0.5">{EMAIL}</span>
            </div>
          </a>

          {/* Phone */}
          <a
            href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`}
            className="flex items-center gap-2 bg-stone-700 hover:bg-stone-800 text-white text-xs font-bold px-4 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.15)" }}
          >
            <i className="ri-phone-line text-base"></i>
            <div className="flex flex-col leading-none">
              <span>Call Us</span>
              <span className="text-stone-300 font-normal text-[10px] mt-0.5">{PHONE_NUMBER}</span>
            </div>
          </a>
        </div>
      )}

      {/* Main toggle button */}
      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className={`w-14 h-14 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer ${
            open ? "bg-gray-700 hover:bg-gray-800" : "bg-green-500 hover:bg-green-600"
          }`}
          style={{ boxShadow: "0 4px 20px rgba(0,0,0,0.22)" }}
          aria-label="Contact us"
        >
          <i className={`text-white text-2xl transition-transform duration-300 ${open ? "ri-close-line rotate-90" : "ri-customer-service-2-line"}`}></i>
        </button>

        {/* Pulse ring when closed */}
        {!open && (
          <span className="absolute inset-0 rounded-full bg-green-400/40 animate-ping pointer-events-none"></span>
        )}
      </div>
    </div>
  );
}
